import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { login } from "../../../config/Redux/Auth/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoHeader, loginHandSign } from "../../../assets/index";
import "./Login.css";

const validationSchema = yup.object().shape({
  email: yup.string().required("Silahkan Masukan Email"),
  password: yup.string().required("Silahkan Masukan Kata Sandi"),
});

const Login = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [errorLogin, setErrorLogin] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
    });
    return has;
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let payload = {
        email: values.email,
        password: values.password,
      };
      const resp = await dispatch(login(payload));
      if (resp) {
        let checkLevelExco = resp.payload.data.id_tingkat_exco;
        let hak_akses = resp.payload.data.hak_akses;

        if (resp.type === "LOGIN_SUCCESS") {
          if (checkHakAkses(hak_akses, "Overview Access")) {
            return navigate(`/overview`);
          } else if (
            checkHakAkses(hak_akses, "Document Admin Access") ||
            checkHakAkses(hak_akses, "Document Manager Access") ||
            checkHakAkses(hak_akses, "Document Viewer Only Access")
          ) {
            if (checkLevelExco === 1) {
              return navigate(`/`);
            }
            if (checkLevelExco === 2) {
              return navigate(`/provinsi`);
            }
            if (checkLevelExco === 3) {
              return navigate(`/kab-kot`);
            }
            if (checkLevelExco === 4) {
              return navigate(`/kecamatan`);
            }
          } else {
            return navigate(`/user-management`);
          }
        } else {
          setErrorLogin(true);
          setErrorMessage(resp.payload.data?.message);
        }
      }
    },
  });

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img src={logoHeader} alt="Partai Buruh Logo" />
        </div>

        <div className="login-greeting">
          <img src={loginHandSign} alt="Login Hand Sign" />
          <h2>Halo, Selamat Datang!</h2>
        </div>

        {errorLogin && <div className="login-error">{errorMessage}</div>}

        <form className="login-form" onSubmit={formik.handleSubmit}>
          <div className="login-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              className={`login-input ${formik.touched.email && formik.errors.email ? "error" : ""}`}
              placeholder="example@gmail.com"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.email && formik.errors.email && (
              <span className="field-error">{formik.errors.email}</span>
            )}
          </div>

          <div className="login-field">
            <label htmlFor="password">Kata Sandi</label>
            <div className="login-input-wrapper">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                className={`login-input ${formik.touched.password && formik.errors.password ? "error" : ""}`}
                placeholder="••••••••••••••••"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={handleClickShowPassword}
                aria-label="toggle password visibility"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </button>
            </div>
            {formik.touched.password && formik.errors.password && (
              <span className="field-error">{formik.errors.password}</span>
            )}
          </div>

          <button type="submit" className="login-button">
            Masuk
          </button>
        </form>

        {/* <div className="forgot-password">
          <a href="#">Lupa Kata Sandi?</a>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
